import React from 'react';
import { Row, Button } from "react-bootstrap";
import { Dialog } from 'primereact/dialog';

const PolicyDialogs = ({
  visibleSecurityPol,
  setVisibleSecurityPol,
  visiblePrivacyPol,
  setVisiblePrivacyPol,
  visibleConnectionAccess,
  setVisibleConnectionAccess,
  visiblePersonalData,
  setVisiblePersonalData
}) => {
  return (
    <>
      <Dialog 
        header="Gizlilik Sözleşmesi" 
        visible={visibleSecurityPol} 
        style={{ width: '50vw' }} 
        onHide={() => { if (!visibleSecurityPol) return; setVisibleSecurityPol(false); }}
      >
        <div className="p-dialog-content">
          <p className="m-0">
            Osmanlı Yatırım Menkul Değerler A.Ş. (Osmanlı Yatırım) müşteri memnuniyeti ve güvenliği odaklı hizmet felsefesi ile yatırım kuruluşlarının faaliyetleri gereği, işbu web sitesi www.osmanlimenkul.com.tr (bundan sonra "Web Sitesi" olarak ifade edilecektir.) vermiş olduğunuz bilgilerin gizliliğini korumak amacıyla aşağıda belirtilen temel kuralları benimsemektedir. Web Sitesi'ne girilen bilgilerin güvenliği açısından Kurumumuz sistem ve internet altyapısı en güvenilir seviyede tutularak gerekli önlemler alınmıştır. Müşterilerimizin Web Sitemiz 'e ürün/hizmet başvurusu ve bilgi güncelleme amaçlı girmiş oldukları bilgiler diğer internet kullanıcıları tarafından görüntülenemez. Müşterilerimizin bizimle paylaştığı bilgilere izinsiz ulaşım, Osmanlı Yatırım personeli dahil olmak üzere kısıtlanmıştır. Osmanlı Yatırım, söz konusu bilgileri müşterilerin onayı dışında ya da yasal bir yükümlülük altında bulunmadığı sürece herhangi bir üçüncü şahıs, kurum ve kuruluş ile paylaşmayacaktır. Osmanlı Yatırım, bu bilgileri sadece gerekli yetkiler ve yasal düzenlemeler çerçevesinde açıklayabilecektir. Osmanlı Yatırım'ın tabi olduğu düzenleyici kurumlar ve/veya yasama, yürütme organ ve mercileri müşteri bilgilerinin açıklanmasını istediğinde, Osmanlı Yatırım, bu bilgileri yalnızca gerekli yetkiler çerçevesinde açıklayacaktır.
          </p>
        </div>

        <Row style={{ display: "block" }} className="m-0">
          <Button 
            slot="end" 
            variant="dark" 
            className="custom-button m-t-20 m-b-0" 
            onClick={() => setVisibleSecurityPol(false)}
          >
            KAPAT
          </Button>
        </Row>
      </Dialog>

      <Dialog 
        header="KİŞİSEL VERİLERİN KORUNMASI HAKKINDA BİLGİLENDİRME" 
        visible={visiblePrivacyPol} 
        style={{ width: '50vw' }} 
        onHide={() => { if (!visiblePrivacyPol) return; setVisiblePrivacyPol(false); }}
      >
        <div className="p-dialog-content">
          <p className="m-0">
            Osmanlı Yatırım Menkul Değerler A.Ş. olarak, 07 Nisan 2016 tarihinde yürürlüğe giren 6698 Sayılı Kişisel Verilerin Korunması Kanunu ("Kanun") uyarınca, Veri Sorumlusu sıfatıyla hazırladığımız işbu bilgilendirme yazısı ile sizlere, Kanun'da yer alan "Veri Sorumlusunun Aydınlatma Yükümlülüğü" başlıklı 10. maddesi ve "İlgili Kişinin Hakları" başlıklı 11. Maddeleri başta olmak üzere Kanun çerçevesinde; kişisel verilerinizin hangi amaçla işlenebileceği, kimlere ve hangi amaçlarla aktarılabileceği, kişisel verilerinizin toplanmasının yöntemi ve hukuki sebebi ile ilgili olarak sizleri bilgilendirmek isteriz.
          </p>
          <p className="m-0">
            Kişisel Verilerin İşlenme Amaçları ve Hukuki Sebepleri: Kanun gereğince, kişisel verileriniz, Tarafımızca Veri Sorumlusu sıfatıyla, Kanun'un 5. ve 6. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları çerçevesinde ve Kanun'un izin verdiği ölçüde işlenebilecektir. Bu kapsamda, kişisel verileriniz; Osmanlı Yatırım'ın sunduğu hizmetlerin yürütülmesi, müşteri ilişkilerinin yönetilmesi, yasal yükümlülüklerin yerine getirilmesi, ticari faaliyetlerin yürütülmesi, pazarlama ve reklam faaliyetlerinin gerçekleştirilmesi gibi amaçlarla işlenmektedir.
          </p>
          <p className="m-0">
            Kişisel Verilerin Aktarılması: Kişisel verileriniz, Kanun'da belirtilen koşullar çerçevesinde, hizmet aldığımız iş ortakları, yasal düzenleyici ve denetleyici kurumlar ile yasal yükümlülüklerin yerine getirilmesi amacıyla ilgili üçüncü taraflarla paylaşılabilir.
          </p>
          <p className="m-0">
            Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebebi: Kişisel verileriniz, doğrudan tarafınızdan alınmakta olup, Kanun'un 5. ve 6. maddelerinde belirtilen hukuki sebeplerle işlenmektedir.
          </p>
          <p className="m-0">
            İlgili Kişi Olarak Haklarınız: Kanun'un 11. maddesi uyarınca, kişisel verilerinizle ilgili olarak aşağıdaki haklara sahipsiniz:
          </p>
          <ul>
            <li>a. Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
            <li>b. İşlenmişse buna ilişkin bilgi talep etme,</li>
            <li>c. Kişisel verilerinizin işlenme amacını ve amaca uygun kullanılıp kullanılmadığını öğrenme,</li>
            <li>d. Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,</li>
            <li>e. Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme,</li>
            <li>f. Kanun ve ilgili diğer kanun hükümlerine uygun olarak kişisel verilerinizin silinmesini veya yok edilmesini isteme,</li>
            <li>g. İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme,</li>
            <li>h. Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme.</li>
          </ul>
          <p className="m-0">
            Haklarınızı kullanmak için bizimle iletişime geçebilirsiniz. Başvurularınız, Kanun'da belirtilen süreler içinde sonuçlandırılacaktır.
          </p>
        </div>
        
        <Row style={{ display: "block" }} className="m-0">
          <Button 
            slot="end" 
            variant="dark" 
            className="custom-button m-t-10 m-b-10" 
            onClick={() => setVisiblePrivacyPol(false)}
          >
            KAPAT
          </Button>
        </Row>
      </Dialog>

      <Dialog 
        header="Header" 
        visible={visiblePersonalData} 
        style={{ width: '50vw' }} 
        onHide={() => { if (!visiblePersonalData) return; setVisiblePersonalData(false); }}
      >
        <p className="m-0">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
          consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
          Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        </p>
      </Dialog>

      <Dialog 
        header="Header" 
        visible={visibleConnectionAccess} 
        style={{ width: '50vw' }} 
        onHide={() => { if (!visibleConnectionAccess) return; setVisibleConnectionAccess(false); }}
      >
        <p className="m-0">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
          consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
          Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        </p>
      </Dialog>
    </>
  );
};

export default PolicyDialogs;
